import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { BorderedStack } from "../../../styled/pos/superficies";
import { parseFloatToFixed } from "../../../../extras";
import { useDispatch, useSelector } from "react-redux";
import { setShowPaymentForm } from "../../../../store/actions/newOrderSlice";
import { LightDarkGreyBox } from "../../../styled";
import { formatFinance } from "../../../../utils/formatters";

const PaymentInfoPanel = ({ submitOrder }) => {
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const total = useSelector((state) => state.newOrder.total);
  const itemsTotal = useSelector((state) => state.newOrder.itemsTotal);
  const applyServiceFee = useSelector(
    (state) => state.newOrder.applyServiceFee
  );
  const serviceFeeAmount = useSelector(
    (state) => state.newOrder.serviceFeeAmount
  );
  const discountsValue = useSelector((state) => state.newOrder.discountsValue);

  const cartProducts = useSelector((state) => state.newOrder.cartProducts);

  const customer = useSelector((state) => state.newOrder.customer);
  const orderType = useSelector((state) => state.newOrder.orderType);
  const address = useSelector((state) => state.newOrder.address);

  const showPaymentForm = useSelector(
    (state) => state.newOrder.showPaymentForm
  );

  const handlePaymentForm = () => {
    if (!orderType) {
      setDialogMessage("Informe se o pedido é para Retirada ou Entrega.");
      setDialogOpen(true);
      return;
    }

    if (!customer && orderType !== "INDOOR") {
      setDialogMessage("Por favor, selecione um cliente.");
      setDialogOpen(true);
      return;
    }

    if (orderType === "DELIVERY" && !address) {
      setDialogMessage("Informe o endereço para entrega do pedido.");
      setDialogOpen(true);
      return;
    }

    dispatch(setShowPaymentForm(true));
  };

  if (!cartProducts || cartProducts.length === 0) {
    return (
      <LightDarkGreyBox sx={{ width: "100%" }}>
        <Typography
          variant="h5"
          align="center"
          display="flex"
          alignItems={"center"}
          fontWeight={700}
          sx={{ mx: "auto", my: 1 }}
        >
          <MonetizationOnIcon /> Resumo do Pagamento
        </Typography>
        <Typography variant="body1" align="center">
          Nada para pagar
        </Typography>
      </LightDarkGreyBox>
    );
  }

  return (
    <LightDarkGreyBox shadow>
      <Typography
        variant="h5"
        align="center"
        display="flex"
        alignItems={"center"}
        fontWeight={700}
        sx={{ mx: "auto", my: 1 }}
      >
        <MonetizationOnIcon /> Resumo do Pagamento
      </Typography>
      <BorderedStack paddingX={2} paddingY={2}>
        <Stack spacing={1}>
          {/* Total Value */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Total:
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {formatFinance(parseFloatToFixed(total))}
            </Typography>
          </Box>

          {/* Items Value */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body2">Itens:</Typography>
            <Typography variant="body2">
              {formatFinance(parseFloatToFixed(itemsTotal))}
            </Typography>
          </Box>

          {/* Delivery Tax */}
          {address?.fee && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2">Taxa de Entrega:</Typography>
              <Typography variant="body2">
                {formatFinance(parseFloatToFixed(address.fee))}
              </Typography>
            </Box>
          )}

          {/* Service Fee */}
          {applyServiceFee && serviceFeeAmount && serviceFeeAmount > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2">Taxa de Serviço:</Typography>
              <Typography variant="body2">
                {formatFinance(parseFloatToFixed(serviceFeeAmount))}
              </Typography>
            </Box>
          )}

          {/* Discounts Value */}
          {discountsValue !== undefined && discountsValue !== null && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2">Descontos:</Typography>
              <Typography variant="body2">
                {formatFinance(parseFloatToFixed(discountsValue))}
              </Typography>
            </Box>
          )}

          {total && total > 0 && !showPaymentForm && (
            <Button variant="contained" onClick={handlePaymentForm}>
              PAGAMENTO
            </Button>
          )}

          {showPaymentForm && (
            <Button variant="contained" color="success" onClick={submitOrder}>
              CRIAR PEDIDO
            </Button>
          )}
        </Stack>
      </BorderedStack>

      {/* Warning Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Aviso</DialogTitle>
        <DialogContent>{dialogMessage}</DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </LightDarkGreyBox>
  );
};

export default PaymentInfoPanel;
